export default import.meta.ROLLUP_FILE_URL_puU3W1aT;